import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  ftsingle_id;
  patient_id;
  referance_id
  author_id
  branch_code
  sex
  lmp
  ga
  edd
  no_of_fetus
  tech_condition
  fetal_heart_beat
  mean_gsd
  crl
  nt_thikness
  amniotic_fluid
  amnionicity
  amniotic_fluids
  p_location
  us_average
  uss_edd
  us_edd
  us_edds
  genders
  right_adnexium
  left_adnexium
  cervical_os
  bpd
  fl
  ac
  hc
  efw
  other_finding
  comments
  suggestion1
  suggestion2
  suggestion3
  ftimage
  fin_year
  entry_date
  update_entry_date
  doctor_id

  patient;
  FetchPatient;
  Patient_type: any =[]
  gender: any =[]
  AmnioticFluid: any = []
  CervicalOs: any = []
  Chorionicity: any = []
  Amnionicity: any = []
  Grade: any = []
  PlacentaLocation: any = []
  PlacentaLocationAnatomic: any = []
  Presentation: any = []
  FetalAnomaly: any = []
  NoofFetus: any = []
  TechnicalConditions: any = []
  FetalHeartBeat: any = []
  fetal_movement: any = []
  image1: any = []
  image2: any = []
  templates: any = []
  buildLoad: boolean = false
  freshLoad: boolean = false
  resload:boolean = false
  htmlStr
  isSaveLoading
  message
  resultLoad: boolean = true
  trimester
  no_of_fetuss
  PATIENT_NAME
  REFERRED_BY
  PATIENT_AGE

  constructor() { }

  ngOnInit(): void {
  }

}
